"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UISubheader = _interopRequireDefault(require("UIComponents/layout/UISubheader"));

var _UITabs = _interopRequireDefault(require("UIComponents/nav/UITabs"));

var _UITab = _interopRequireDefault(require("UIComponents/nav/UITab"));

var _UIMultiColumn = _interopRequireDefault(require("UIComponents/layout/UIMultiColumn"));

var _UIMultiColumnGroup = _interopRequireDefault(require("UIComponents/layout/UIMultiColumnGroup"));

var _UIMultiColumnItem = _interopRequireDefault(require("UIComponents/layout/UIMultiColumnItem"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _RequestStatusTypes = _interopRequireWildcard(require("settings-ui-sdk/constants/RequestStatusTypes"));

var MIN_SEARCHABLE_LENGTH = 6;

var getIsLoading = function getIsLoading(status) {
  return [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.PENDING].includes(status);
};

var ContentMembershipSettingsHeader =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ContentMembershipSettingsHeader, _PureComponent);

  function ContentMembershipSettingsHeader() {
    (0, _classCallCheck2.default)(this, ContentMembershipSettingsHeader);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ContentMembershipSettingsHeader).apply(this, arguments));
  }

  (0, _createClass2.default)(ContentMembershipSettingsHeader, [{
    key: "renderDomainPicker",
    value: function renderDomainPicker() {
      var _this$props = this.props,
          domainOptions = _this$props.domainOptions,
          selectedDomain = _this$props.selectedDomain,
          domainOptionsRequestStatus = _this$props.domainOptionsRequestStatus;
      var isLoading = getIsLoading(domainOptionsRequestStatus);
      return _react.default.createElement(_UISelect.default, {
        "data-test-id": "domain-input",
        buttonUse: "transparent",
        options: domainOptions,
        searchable: domainOptions.length > MIN_SEARCHABLE_LENGTH,
        value: selectedDomain,
        onChange: this.props.onSelectedDomainChange,
        disabled: isLoading,
        menuWidth: 300
      });
    }
  }, {
    key: "renderDomainHeader",
    value: function renderDomainHeader() {
      return _react.default.createElement(_UIMultiColumn.default, {
        className: "m-bottom-10"
      }, _react.default.createElement(_UIMultiColumnGroup.default, null, _react.default.createElement(_UIMultiColumnItem.default, {
        horizontalAlign: "left"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "marketing.pages.modifying"
      }), this.renderDomainPicker()), _react.default.createElement(_UIMultiColumnItem.default, {
        horizontalAlign: "right",
        verticalAlign: "middle"
      }, _react.default.createElement(_UIButton.default, {
        use: "tertiary-light",
        size: "small",
        href: "/domains/" + _hubspot.default.get()
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "marketing.pages.buttonLabels.manageDomains"
      })))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          activeTab = _this$props2.activeTab,
          showTemplatesTab = _this$props2.showTemplatesTab;
      return _react.default.createElement("div", null, _react.default.createElement(_UISubheader.default, {
        use: "condensed",
        className: "m-bottom-0",
        title: _react.default.createElement(_FormattedMessage.default, {
          message: "contentMembership.header"
        })
      }), this.renderDomainHeader(), _react.default.createElement(_UITabs.default, {
        use: "enclosed",
        selected: activeTab,
        onSelectedChange: this.props.onSelectedTabChange,
        className: "content-membership-tabs m-bottom-10"
      }, _react.default.createElement(_UITab.default, {
        className: "content-membership-tabs-general",
        tabId: _UrlPathParams.GENERAL,
        title: _react.default.createElement(_FormattedMessage.default, {
          message: "contentMembership.buttonLabels.general"
        })
      }), showTemplatesTab && _react.default.createElement(_UITab.default, {
        className: "content-membership-tabs-templates",
        tabId: _UrlPathParams.TEMPLATES,
        title: _react.default.createElement(_FormattedMessage.default, {
          message: "contentMembership.buttonLabels.templates"
        })
      })));
    }
  }]);
  return ContentMembershipSettingsHeader;
}(_react.PureComponent);

ContentMembershipSettingsHeader.propTypes = {
  activeTab: _react.PropTypes.string.isRequired,
  domainOptions: _react.PropTypes.array.isRequired,
  onSelectedDomainChange: _react.PropTypes.func.isRequired,
  onSelectedTabChange: _react.PropTypes.func.isRequired,
  selectedDomain: _react.PropTypes.string.isRequired,
  domainOptionsRequestStatus: _RequestStatusTypes.RequestStatusPropType.isRequired,
  showTemplatesTab: _react.PropTypes.bool.isRequired
};
var _default = ContentMembershipSettingsHeader;
exports.default = _default;
module.exports = exports.default;